import Router from '../libs/Router';

export default new Router();
